import { observable } from 'mobx';

const RefundListModel = observable({
    columns : [],
    tabs : [],
    setColumns(columns) {
        this.columns = columns || []
    },
    setTabs(tabs) {
        this.tabs = tabs.map((tab) => {
            return {
                name : tab.name || "",
                taxRefundGridTabType : tab.taxRefundGridTabType || null,
                count : tab.count || 0
            }
        })
    }
});

export default RefundListModel;